import React from "react";
import { makeStyles, Theme } from "@material-ui/core/styles";
import { Container, FleetaLogoOnly } from "@thingsw/pitta-design-system";

import { AppBar } from "./AppBar";
import { Toolbar } from "./Toolbar";
import { Link } from "react-router-dom";

const useStyles = makeStyles((theme: Theme) => ({
  vcenter: {
    display: "flex",
    alignItems: "center",
  },
  grow: {
    display: "flex",
    flexGrow: 1,
    justifyContent: "flex-end",
    alignItems: "center",
  },
  headerText: {
    marginRight: theme.spacing(2),
  },
  appBar: {
    // border: 0,
  },
}));

export const ResetHeader = () => {
  const classes = useStyles();

  return (
    <AppBar color="default" className={classes.appBar}>
      <Container>
        <Toolbar>
          <Link to="/" className={classes.vcenter}>
            <FleetaLogoOnly />
          </Link>
        </Toolbar>
      </Container>
    </AppBar>
  );
};
